import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MasterAllResponse } from 'src/app/orange/models/masterAllResponse';
import { AppState } from 'src/app/orange/redux';
import { filteredPrepaidOrderList, resetPrepaidOrderList, resetState, setMasterAll, setPrepaidOrderList } from 'src/app/orange/redux/orange.actions';
import { IOrangePrepaidState } from 'src/app/orange/redux/orange.state';
import { OrangePrepaidHiringService } from 'src/app/orange/services/orange-prepaid-hiring.service';
import { OrangeService } from 'src/app/orange/services/orange.service';
import { listSortByDate, superStatus, superStatusTranslate } from 'src/app/shared/constantes';
import * as moment from 'moment/moment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { PrepaidOrderListRequest, PrepaidOrderListResponse } from 'src/app/orange/models/prepaidInfoResponse';
import { DigoService } from 'src/app/services/digo.service';

@Component({
    selector: 'app-orange-prepaid-list',
    templateUrl: './orange-prepaid-list.component.html',
    styleUrls: ['./orange-prepaid-list.component.css', '../../../../../assets/css/orange-theme.css'],
    standalone: false
})
export class OrangePrepaidListComponent implements OnInit {

    public orange$: Observable<IOrangePrepaidState>;
    public lastPage: number = 0;
    public formGroup: FormGroup;
    public loaded: boolean = false;
    public errorSearch: boolean = false;
    public isCollapsed: boolean = true;
    public minDate: Date;
    public maxDate: Date;
    public faCalendarDay = faCalendarDay;
    public superStatusTranslate = superStatusTranslate;
    public body: PrepaidOrderListRequest = {
        limit: 50,
        page: 1,
        filters: null,
        order: {
            created_at: 'desc'
        }
    };

    public listSortByDate = listSortByDate;
    private automaticLoad: boolean = true;

    public listSuperStatuses: any[] = [{ label: "Todas", value: "" }];

    constructor(
        private orangePrepaidHiringService: OrangePrepaidHiringService,
        private orangeStore: Store<AppState>,
        private formBuilder: FormBuilder,
        private digoService: DigoService,
        private orangeMasterService: OrangeService
    ) {
        this.orange$ = orangeStore.pipe(select('orangePrepaid'));
    }

    ngOnInit(): void {
        this.doKeepAlive();
        this.formGroup = this.formBuilder.group({
            full_name: [''],
            document: [''],
            msisdn_movil: [''],
            min_date: [''],
            max_date: [''],
            status: [''],
            sort_by_date: ['desc']
        });

        this.orangeMasterService.getMasterAllFromService()
            .subscribe((data: MasterAllResponse) => {
                if (data?.msg) {
                    this.orangeStore.dispatch(setMasterAll({ master: data.msg }));
                    this.getOrders();
                }
            }, error => {
                console.error('getMasterAllFromService', error);
                this.getOrders();
            });

        // Observa el store pero solo actualiza `listSuperStatuses` si realmente cambia
        this.orange$.subscribe((data) => {
            const statuses = data?.master?.super_statuses?.map((status) => ({
                label: superStatusTranslate[status.super_status_id],
                value: status.value
            })) ?? [];

            const newList = [{ label: 'Todas', value: '' }, ...statuses];

            // Comparación segura por valor
            const stringify = (arr) => JSON.stringify(arr.map((o) => o.value));
            if (stringify(newList) !== stringify(this.listSuperStatuses)) {
                this.listSuperStatuses = newList;
            }
        });
    }

    public advanceSearch() {
        const formData = this.formGroup.getRawValue();
        const filters: any = {};

        if (formData.full_name !== '') {
            filters.customer_full_name = formData.full_name;
        }
        if (formData.document !== '') {
            filters.customer_document = formData.document;
        }
        if (formData.msisdn_movil !== '') {
            filters.msisdn = formData.msisdn_movil;
        }
        if (formData?.status) {
            filters.statuses = Array.isArray(formData.status) ? formData.status : [!isNaN(formData.status) ? (Number(formData.status)) : formData.status];
        }
        if (formData.sort_by_date) {
            this.body.order.created_at = formData.sort_by_date;
        }
        if (formData.min_date != null && formData.max_date != null && formData.min_date !== '' && formData.max_date !== '') {
            filters.created_at = 'bt|' + moment(formData.min_date).format('YYYY-MM-DD 00:00:00') + '|' + moment(formData.max_date).format('YYYY-MM-DD 23:59:59');
        } else if (formData.min_date != null && formData.min_date !== '') {
            filters.created_at = 'gte|' + moment(formData.min_date).format('YYYY-MM-DD 00:00:00');
        } else if (formData.max_date != null && formData.max_date !== '') {
            filters.created_at = 'lte|' + moment(formData.max_date).format('YYYY-MM-DD 23:59:59');
        }

        this.body.page = 1;
        this.body.filters = filters;
        this.orangeStore.dispatch(resetPrepaidOrderList());
        this.automaticLoad = true;

        this.getOrders();
    }

    doKeepAlive() {
        this.digoService.keepAlive()
            .subscribe({
                next: (resp: any) => {
                    if (!resp || resp !== 200) {
                        this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive, resp: ' + resp + ' - orange-prepaid-list.component - doKeepAlive');
                        this.digoService.goLogin();
                    }
                }
                , error: (error: HttpErrorResponse) => {
                    this.digoService.sendDataToLogs('log: Logout de usuario - Logout keepAlive Error response: ' + error.message + '- orange-prepaid-list.component - doKeepAlive');
                    this.digoService.goLogin();
                }
            });
    }

    public searchClient(text: string) {
        this.orangeStore.dispatch(filteredPrepaidOrderList({ text }));
    }

    @HostListener('window:scroll', ['$event'])
    public doSomethingOnWindowScroll(event: Event) {
        if (this.automaticLoad) {
            const element: any = event.srcElement;
            const scrollOffset = element.children[0].scrollTop;
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight - 200;

            if (scrollOffset > windowHeight && windowHeight > 0) {
                console.log('Cargando siguiente página. A partir de ahora se carga en manual.');
                this.automaticLoad = false;
                this.nextPage();
            }
        }
    }

    public loadMore() {
        this.nextPage();
    }

    public setMinDate(event: MatDatepickerInputEvent<Date>) {
        this.minDate = event.value;
    }

    public setMaxDate(event: MatDatepickerInputEvent<Date>) {
        this.maxDate = event.value;
    }

    public convertStatusClass(status): string {
        switch (status) {
            case superStatus.active:
                return 'dot-complete';
            case superStatus.cancelled:
            case superStatus.error:
            case superStatus.rejected:
                return 'dot-cancel';
            default:
                return 'dot-pending';
        }
    }

    private getOrders() {
        this.loaded = false;
        this.errorSearch = false;
        this.orangePrepaidHiringService.listPrepaid(this.body)
            .subscribe((data: PrepaidOrderListResponse) => {
                this.orangeStore.dispatch(setPrepaidOrderList({ orderList: data.msg }));
                this.lastPage = data.msg.last_page;
            }, (error: HttpErrorResponse) => {
                this.errorSearch = true;
                this.loaded = true;
            }, () => {
                this.loaded = true;
            });
    }

    private nextPage() {
        if (this.body.page < this.lastPage) {
            this.body.page += 1;
            this.getOrders();
        }
    }

    public getOrderType(lines: any): string {
        const line = lines[0];
        if (line.is_esim) {
            return line.portability ? 'Portabilidad eSIM Prepago' : 'Alta eSIM prepago';
        }
        if (line.portability) {
            return 'Portabilidad prepago';
        }
        return 'Alta prepago';
    }

    public numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;

        return !(charCode > 31 && (charCode < 48 || charCode > 57));
    }

    ngOnDestroy() {
        this.orangeStore.dispatch(resetState());
    }

}
